import React, { useState, useEffect, useMemo } from 'react';  
import { useLocation } from 'react-router-dom';  
import useCustomNavigate from '../../common_nextgen/common_components/Navigation/NextGenNavigation';  
import Form from '../../common_nextgen/common_components/form/Form';  
import { PRICE_SCHEDULE_MODES } from '../../common_nextgen/utils/Constants';  
import { useAxios } from '../../common_nextgen/axios/AxiosHelper';  
import ConfirmationModal from '../../common_nextgen/common_components/Modal/ConfirmationModal';  
import { useToast } from '../../common_nextgen/hooks/ToastContext';  
import FunctionKeys from '../../common_nextgen/common_components/FunctionKeys/FunctionKeys';
import {
    isAddMode,
    isEditMode,
    isReadOnlyMode,
  } from "../../common_nextgen/utils/UtilFunctions";  
  import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants"; 

import { formFields } from './DiscountPatientPayTableFormConfig';
  
const screenInfo = {  
  ADD: ['Add Discount Patient Pay Table Detail', 'RCDP3003'],  
  CHANGE: ['Discount Patient Pay Table Detail', 'RCDP3002'],  
  VIEW: ['Discount Patient Pay Table Detail', 'RCDP3002'],  
};  
  
const DiscountPatientPayTableForm = ({ mode }) => { 
  const { DISCOUNT_PATIENT_PAY_TABLE } =
  ROUTE_PATHS; 
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();  
 const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);
  const {
    selectedDiscount = [],
    previousScreen = DISCOUNT_PATIENT_PAY_TABLE,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
  } = currentState;  
 // const { selectedPriceSchedules = [], previousScreen = '/price-schedule', currentIndex: initialIndex = 0 } = {} } = useLocation();  
  const navigateToPage = useCustomNavigate();  
  const [selectedOption, setSelectedOption] = useState('no');  
  const [currentIndex, setCurrentIndex] = useState(initialIndex);  
  const [currentMode, setCurrentMode] = useState(mode);  
  const [initialFormData, setInitialFormData] = useState({});  
  const [dataForSubmission, setDataForSubmission] = useState({});  
  const [constraintErrors, setConstraintErrors] = useState([]);  
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);  
  const [externalMode, setExternalMode] = useState(initialExternalMode);

  const toast = useToast();  
  
  const handleBack = () => {  
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedDiscount.length - 1) {  
      setCurrentIndex(currentIndex + 1);  
      setCurrentMode(mode);  
    } else {  
      navigateToPage(previousScreen, previousState);  
    }  
  };  
  
  
  const getPageTitle = () => {  
    const [screenTitle, screenNumber] = isAddMode(mode) ? screenInfo.ADD : screenInfo.CHANGE;  
    return (  
      <>  
        <span className="title">{screenTitle}</span>  
        <span>{'-'}</span>  
        <span className="screen-number">{screenNumber}</span>  
      </>  
    );  
  };  
  
  
  const submitForm = async (dataForSubmission) => {  
    let url = '';  
    let verb = '';  
    let screenNumber = '';  
  
    if (isAddMode(currentMode)) {  
      url = 'api/DP3DiscountPatPayTbl';  
      verb = 'POST';  
      screenNumber = screenInfo.ADD[1];  
    } else {  
      url = 'api/DP3DiscountPatPayTbl';  
      verb = 'PUT';  
      screenNumber = screenInfo.CHANGE[1];  
  
      if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {  
        toast.current.show({ severity: "info", summary: "", detail: "No Change of Information", life: 3000 });    
        return;  
      }  
    }  
  
    const data = { ...dataForSubmission, screenNumber };  
  
    try {  
      const { responseStatus,responseData } = await axios_helper_no_header(verb, url, data, null);  
      toast.current.show({ severity: "success", summary: "", detail: responseStatus.message, life: 3000 });  
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const [previousLastRecord = {}] = previousState.splice(
          previousState.length - 1,
          1
        );
        const { paramsData = {} } = previousLastRecord;
        const updatedParamsData = {
          ...paramsData,
          dp3DiscountTableId: responseData["dp3DiscountTableId"],
        };
        const updatedPreviousState = [
          ...previousState,
          { ...previousLastRecord, paramsData: updatedParamsData },
        ];
        const updatedCurrentState = {
          ...currentState,
          selectedDiscount: [{ ...responseData }],
          currentIndex: 0,
          previousScreen: previousScreen,
        };
        navigateToPage(ROUTE_PATHS.DISCOUNT_PATIENT_PAY_TABLE_EDIT, [
          ...updatedPreviousState,
          { ...updatedCurrentState},
        ]);
        setStateVal([...updatedPreviousState, { ...updatedCurrentState }]);
      }
        else {
          setInitialFormData(responseData);
        }
      
    } catch (error) {  
      const { responseStatus: { displayErrorFields = null, message } } = error.data;  
      if (displayErrorFields === null) {  
        toast.current.show({ severity: "error", summary: "", detail: message, life: 3000 });  
      } else {  
        setConstraintErrors(displayErrorFields);  
      }  
    }  
  };  
  
  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    keyFunc["F12"] = handleBack;
    keyName["F12"] = "Back";

    if (isAddMode(currentMode)) {
    } else if (isEditMode(currentMode)) {
      keyFunc["chmod"] = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName["chmod"] = "View";
      keyName.F7 = "Prescriber Networks";
      keyFunc.F7 = () => {
        navigateToPage(ROUTE_PATHS.PRESCRIBER_NETWORKS, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            currentIndex: 0,
            selectedSchedules: [selectedDiscount[currentIndex]],
          },
        ]);
      };
      keyName.F8 = "Pharmacy Networks";
      keyFunc.F8 = () => {
        navigateToPage(ROUTE_PATHS.PHARMACY_NETWORKS, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            currentIndex: 0,
            selectedSchedules: [selectedDiscount[currentIndex]],
          },
        ]);
      };
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc["chmod"] = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName["chmod"] = "Edit";
      keyName.F7 = "Prescriber Networks";
      keyFunc.F7 = () => {
        navigateToPage(ROUTE_PATHS.PRESCRIBER_NETWORKS, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            currentIndex: 0,
            selectedSchedules: [selectedDiscount[currentIndex]],
          },
        ]);
      };
      keyName.F8 = "Pharmacy Networks";
      keyFunc.F8 = () => {
        navigateToPage(ROUTE_PATHS.PHARMACY_NETWORKS, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            currentIndex: 0,
            selectedSchedules: [selectedDiscount[currentIndex]],
          },
        ]);
      };
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, initialFormData, externalMode]);  
  
  useEffect(() => {  
    const fetchInitialData = async () => {  
      const url = isAddMode(currentMode)?`api/DP3DiscountPatPayTbl/initialFormData/${encodeURIComponent(screenInfo.ADD[1])}`:`api/DP3DiscountPatPayTbl/${encodeURIComponent(selectedDiscount[currentIndex].dp3DiscountTableId)}`;  
      const { responseData } = await axios_helper_no_header('GET', url);  
      setInitialFormData(responseData);  
    };  
  
    if (!isAddMode(currentMode) && !selectedDiscount?.[currentIndex]?.dp3DiscountTableId) return;
    fetchInitialData();  
  }, [mode, currentIndex, currentMode, selectedDiscount[currentIndex]]);
  
  const handleMessage = (event) => {
      const { type, data } = event.data;
      console.log("iframe load", type, data);
      if (type === "set-params") {
        setStateVal(data);
        setExternalMode(true);
      }
      console.log("message", event.data);
    };
  
    useEffect(() => {
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    });
  
  return (  
    <div className="grid container">  
      <div className="col col-12">  
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />  
      </div>  
      <div className="col col-12">  
        <h1>{getPageTitle()}</h1>  
      </div>  
      <div className="col col-12">  
        <Form  
          formData={initialFormData}  
          formFields={formFields}  
          mode={currentMode}  
          submitFormData={submitForm}  
          constraintErrors={constraintErrors}  
        />  
      </div> 
      </div>  
    );  
};  
export default DiscountPatientPayTableForm;  